import { render, staticRenderFns } from "./MasterclassCard.vue?vue&type=template&id=4362427a&scoped=true&"
import script from "./MasterclassCard.vue?vue&type=script&lang=js&"
export * from "./MasterclassCard.vue?vue&type=script&lang=js&"
import style0 from "./MasterclassCard.vue?vue&type=style&index=0&id=4362427a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4362427a",
  null
  
)

export default component.exports